<div class="container">
  <flo-funnel-checkout-header></flo-funnel-checkout-header>
  <h1 data-test="funnel-title" class="funnel-title">{{ title$ | async }}</h1>
    
    <!-- 
      TODO: remove steps temporarily for isInReorderExp. New stepper will be implemented in near future
      https://flocasts.atlassian.net/browse/CXP-4267 
    -->

    <ng-container *ngIf="isInImageStyleStepperVariation$ | async; else textStyleStepper">
      <flo-stepper-wrapper data-test="stepper" ></flo-stepper-wrapper>
    </ng-container>
    <ng-template #textStyleStepper>
      <p
        *ngIf="!(isInReorderFunnelVariation$ | async)"
        class="flo-footnote"
        [ngClass]="{ 'invisible': isEmebeddedPurchase$ | async }"
      >
        {{ stepsText$ | async }}
      </p>
    </ng-template>

  <div class="funnel-button-wrapper">
    <button
      data-id="pay-button"
      floAnalytics
      name="Go To Pay"
      class="btn btn-primary btn-lg selection-btn w-100"
      data-test="go-to-pay-button"
      (click)="goToNextPage()"
      >Next
    </button>
  </div>

  <div class="main-content">
    <ng-container *ngIf="isInNewPricingArchitectureVariation$ | async; else displayOldPlans">
      <flo-offers data-test="offers" [isVerticalLayout]="isVerticalLayout$ | async"></flo-offers>
    </ng-container>
    <ng-template #displayOldPlans>
      <flo-legacy-plans data-test="plans"></flo-legacy-plans>
    </ng-template>
    <!-- only displayed on mobile view -->
    <div
      *ngIf="valueProps$ | async as valueProps"
      [ngClass]="{
        'd-block': !(isVerticalLayout$ | async),
        'd-md-none': !(isVerticalLayout$ | async)
      }"
      class="mobile-value-props"
      data-test="mobile-value-props"
    >
      <div class="plan-props-header"><h4>Included with the Selected Plan</h4></div>
      <flo-value-prop
        *ngFor="let valueProp of valueProps; trackBy: trackById" 
        label="checkmark-green"
        [proposition]="valueProp"
        svgWidth="18">
      </flo-value-prop>
    </div>
  </div>
</div>